/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Subtitle_File_AriaInputs */



/**
* | output |
* | --- |
* | "Export subtitle file" |
*
* @param {File_Export_Subtitle_File_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_subtitle_file_aria = /** @type {((inputs?: File_Export_Subtitle_File_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Subtitle_File_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter un fichier de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertiteldatei exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta file sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт файла субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar archivo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出字幕文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕ファイルをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक फ़ाइल निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar arquivo de legenda")
	return /** @type {LocalizedString} */ ("Export subtitle file")
});